import { render, staticRenderFns } from "./InputSeatPositionBtn.vue?vue&type=template&id=34b4dcaa&"
import script from "./InputSeatPositionBtn.vue?vue&type=script&lang=js&"
export * from "./InputSeatPositionBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports